import { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import Seo from "@/components/Seo";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useAdminAuth } from "@/context/AdminAuthContext";

export default function AdminLogin() {
  const { user, login } = useAdminAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch {
      toast.error("Invalid email or password");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-950 px-4">
      <Seo title="Admin Login | CA HVAC Direct" description="Administrator login." />
      <div className="w-full max-w-sm rounded-xl border border-white/10 bg-white p-8 shadow-2xl">
        <div className="flex items-center gap-2.5">
          <img src="/logo.png" alt="" className="h-10 w-10 object-contain" />
          <span className="font-heading text-lg font-black tracking-tight text-slate-900">CA HVAC DIRECT</span>
        </div>
        <h1 className="mt-6 font-heading text-xl font-bold text-slate-900">Admin Sign In</h1>
        <form onSubmit={submit} className="mt-5 space-y-4">
          <div>
            <Label htmlFor="email" className="text-sm text-slate-700">Email</Label>
            <Input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required className="mt-1.5 rounded-sm border-slate-300" data-testid="admin-email" />
          </div>
          <div>
            <Label htmlFor="password" className="text-sm text-slate-700">Password</Label>
            <Input id="password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required className="mt-1.5 rounded-sm border-slate-300" data-testid="admin-password" />
          </div>
          <Button type="submit" disabled={loading} className="w-full rounded-sm bg-sky-700 hover:bg-sky-800" data-testid="admin-login-button">
            {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : "Sign In"}
          </Button>
        </form>
      </div>
    </div>
  );
}
